//src/app/features/dashboard/ClientTaxReturnStats.tsx
import { DashboardContainerHeader } from 'app/layout/dashboardLayout/BoxLayout';
import { useGetTaxReturnStatsQuery } from 'app/services/projects';
import { useEffect, useState } from 'react';
import InAppTaxReturnStatusStats from './admin/stats/InAppTaxReturnStatusStats copy';
import MondayTaxReturnStatusStats from './admin/stats/MondayTaxReturnStatusStats';
import TaxReturnIndividualBusinessStats from './admin/stats/TaxReturnIndividualBusinessStats';
import YearSelector from './shared/YearSelector';

export default function ClientTaxReturnStats({
  onLoad,
}: {
  onLoad: () => void;
}) {
  const [year, setYear] = useState(() => new Date().getFullYear());
  const { data, isLoading } = useGetTaxReturnStatsQuery({
    filters: {
      created_at: year,
    },
  });

  useEffect(() => {
    !!data && onLoad();
  }, [data]);

  if (!data) return null;

  return (
    <div className="w-full h-full border border-gray-100 flex flex-1 flex-col min-h-max xl:rounded-tr-3xl xl:rounded-br-3xl rounded-md  overflow-auto">
      <div className="p-2 flex justify-between items-center text-sm border-gray-100 border-b  text-gray-dark font-semibold">
        <div>
          Tax Returns ({data.tax_returns_stats.total_tax_returns_count})
        </div>
        <YearSelector year={year} onChange={setYear} />
      </div>
      <div className="flex flex-wrap w-full h-full overflow-auto">
        <MondayTaxReturnStatusStats data={data} />
        <InAppTaxReturnStatusStats data={data} />
        <TaxReturnIndividualBusinessStats data={data} />
      </div>
    </div>
  );
}
